import { useFormat } from '@ideavivat/vivat-2';

export const target_date = {
  name: 'กำหนดส่ง',
  width: '6rem',
  // eslint-disable-next-line
  filter: (val: string) => val ? useFormat.date(val).displayShortThaiDate() : '',
};

export default {
  types: {
    _increment: {
      name: 'ลำดับ',
      width: '3rem',
    },
    bom_item: {
      name: 'Sub Job No.',
      width: '8rem',
      // eslint-disable-next-line
      filter: (val: any) => val?.job_no ? val?.job_no : '',
    },
    code: {
      name: 'รหัสชิ้นส่วน',
      width: '12rem',
      filter: (val: string, row: { item: { [key: string]: any }; index: number }) => {
        if (row.item.material?.code) return row.item.material?.code;
        return row.item?.bom_item?.material_code;
      },
    },
    material: {
      name: 'วัสดุ',
      width: '1fr',
      filter: (val: any, row: { item: any }) => `${row.item.material?.name || ''}`,
    },
    amount: {
      name: 'จำนวนที่สั่ง / รับแล้ว',
      width: '8rem',
      filter: (val: string) => parseFloat(val).toLocaleString('th-TH', { minimumFractionDigits: 0, maximumFractionDigits: 2 }),
    },
    // filledAmount: {
    //   name: 'จำนวนที่ได้รับแล้ว',
    //   width: '8rem',
    //   filter: (val: string) => parseFloat(val).toLocaleString('th-TH', { minimumFractionDigits: 0, maximumFractionDigits: 2 }),
    // },
    addedAmount: {
      name: 'จำนวนที่รับ',
      width: '8rem',
      filter: (val: string) => parseFloat(val).toLocaleString('th-TH', { minimumFractionDigits: 0, maximumFractionDigits: 2 }),
    },
    stockLocation: {
      name: 'ตำแหน่งจัดเก็บ',
      width: '14rem',
      class: 'overflow-visible has-multiselect',
    },
    purchase_unit: {
      name: 'หน่วย',
      width: '6rem',
      // eslint-disable-next-line
      filter: (val: any, row: { item: any }) => `${val ? val : row.item.material?.unit || ''}`,
    },
    target_date,
    created_at: {
      name: 'วันทำรายการ',
      width: '12rem',
      // eslint-disable-next-line
      filter: (val: string) => val ? useFormat.date(val).displayShortThaiDateTime() : '',
    },

  },

};
